import { Typography, Button, TextField } from '@mui/material';
import AdditionalTerms from '../landing/AdditionalTerms';
import Footer from '../landing/Footer';
import Header from '../landing/Header';
import shl_content_image from '../../../assets/shl_content_image.png';
import { useState } from 'react';
import { uiStore } from '../../modules/datastores/useUiStore';
import { useLocation, useSearch } from 'react-location';
import { SurvivorsConversationStore } from '../../modules/datastores/useGetSurvivorsConversation';
import { useSubmitCode } from '../../modules/datastores/useWaitViaSMS';

const SmsFeedbackCode = () => {
  const [uniqueCode, setUniqueCode] = useState('');
  const location = useLocation();
  const query = useSearch();
  const link = query['link'] as string;
  const { mutateAsync: mutateSubmitCode, error, isError } = useSubmitCode();

  const handleUniqueCode = (e: any): void => {
    e.preventDefault();
    if (uniqueCode) {
      mutateSubmitCode(
        { code: uniqueCode, link },
        {
          onSuccess(data) {
            location.history.replace(`/ingress/feedback-form?task_sid=${data?.task_sid}&form_id=${data?.form_id}`);
            SurvivorsConversationStore.updateSmsFormData(data);
          },
          onError() {
            uiStore.setErrorMessage('Please enter unique identifier.');
          },
        }
      );
    }
  };

  return (
    <>
      <Header />
      <div className="bg-pc-1 py-8">
        <div className="px-4 md:px-14">
          <Typography variant="h1" className="text-tc-4 flex justify-center text-2xl font-bold md:text-left text-center">
            The {process.env.NX_ORGANIZATION_NAME} Online Hotline
          </Typography>
          <Typography variant="body1" className="text-xl italic text-center text-tc-1 border-b border-tc-4 pb-3">
            Chat online with a trained staff member who can provide you confidential crisis support.
          </Typography>
        </div>
        <div className="flex flex-col lg:flex-row md:pl-8 sm:pl-0">
          <div className="w-full lg:w-1/2 px-4 md:px-14 py-4">
            <Typography className="text-lg text-tc-1">
              Your privacy and safety are crucial. Please make sure you are in a safe place and that you are using a secure device and Internet connection. Please note that while we have taken
              numerous measures to keep your communications safe while using our site, no Internet transmission is 100% secure.
            </Typography>
            <AdditionalTerms />
            <div>
              <form onSubmit={handleUniqueCode} className="text-base text-tc-2 mt-5 mb-5 ml-3">
                <div className="flex gap-2 mt-3">
                  <TextField
                    className="flex-1 rhs-chat-textfield"
                    placeholder={'Please enter unique value'}
                    value={uniqueCode}
                    label="Unique Identifier"
                    variant="standard"
                    id="standard-basic"
                    error={isError}
                    helperText={(error as any)?.message || (error as any)?.errors[0]}
                    onChange={(ev) => {
                      setUniqueCode(ev.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <br />
                <Button className="button-secondary" type="submit">
                  Submit
                </Button>
              </form>
            </div>
          </div>
          <div className="w-full sm:w-1/2 px-4 md:px-14 py-4 mt-2">
            <div
              className="video"
              style={{
                position: 'relative',
                paddingBottom: '56.25%' /* 16:9 */,
                paddingTop: 25,
                height: 0,
              }}
            >
              <img
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
                src={shl_content_image}
                alt="Some Content"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SmsFeedbackCode;
